import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useInModal } from 'global/components/modal/ModalContext';

export const MODAL_MAX_IMAGE_COLUMNS = 4;

export const getImageColumns = ({ is2xlUp, isXlUp, isLgUp, isMdUp, inModal = false, maxColumns }) => {
  let cols = 2;
  if (is2xlUp) cols = 6;
  else if (isXlUp) cols = 5;
  else if (isLgUp) cols = 4;
  else if (isMdUp) cols = 3;

  const cap = inModal ? MODAL_MAX_IMAGE_COLUMNS : maxColumns;
  if (cap) cols = Math.min(cols, cap);

  return cols;
};

export const useImageColumns = (options = {}) => {
  const { inModal: inModalProp, maxColumns } = options;
  const inModalContext = useInModal();
  const inModal = inModalProp ?? inModalContext;

  const theme = useTheme();
  const is2xlUp = useMediaQuery(theme.breakpoints.up('2xl'));
  const isXlUp = useMediaQuery(theme.breakpoints.up('xl'));
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  return getImageColumns({ is2xlUp, isXlUp, isLgUp, isMdUp, inModal, maxColumns });
};

export default useImageColumns;
